var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { WorkspaceMenuShell, WorkspacePendingMenuContents } from './components';
export const WorkspacePendingMenu = ({ triggerTestId, workspace, }) => (_jsx(WorkspaceMenuShell, { menuContents: _jsx(WorkspacePendingMenuContents, { workspace: workspace }), triggerTestId: triggerTestId, workspaceId: workspace.id }));
_react_refresh_temp_1 = WorkspacePendingMenu;
$RefreshReg$(_react_refresh_temp_1, "WorkspacePendingMenu");
